var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandBorderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.152,
    height: 23.714,
    viewBox: "0 0 21.152 23.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hand_Icon",
    "data-name": "Hand Icon",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sign-language",
    d: "M5.429,17.337a1.723,1.723,0,0,1,1.73-1.73h3.7v-.339H3.384a1.723,1.723,0,0,1-1.73-1.73,1.7,1.7,0,0,1,1.7-1.663h7.507v-.339H1.73A1.723,1.723,0,0,1,0,9.806,1.7,1.7,0,0,1,1.7,8.143h9.161V7.8H3.426A1.723,1.723,0,0,1,1.7,6.074a1.7,1.7,0,0,1,1.7-1.663H13.4L11.865,3.293l-.309-.225a1.7,1.7,0,0,1,2-2.744C21.4,6.034,21.714,6.646,21.714,7.3v8.38a2.036,2.036,0,0,1-1.569,1.982l-4.778,1.124A8.144,8.144,0,0,1,13.5,19H7.125a1.7,1.7,0,0,1-1.7-1.663ZM12.445,4.146Z",
    transform: "translate(19 0) rotate(90)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandBorderIcon);
export default __webpack_public_path__ + "static/media/Hand_Border_Icon.4df524fa886214560b9bdee2c7d844a9.svg";
export { ForwardRef as ReactComponent };